import { createContext, useContext } from 'react'
import { OverlayTriggerState } from 'react-stately'

export const ModalTriggerStateContext =
  createContext<OverlayTriggerState | null>(null)

export const useModalTriggerContext = () => {
  return useContext(ModalTriggerStateContext)
}
